import { render, staticRenderFns } from "./PdfJsViewer.vue?vue&type=template&id=c84ecce0&scoped=true&"
import script from "./PdfJsViewer.vue?vue&type=script&lang=js&"
export * from "./PdfJsViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfJsViewer.vue?vue&type=style&index=0&id=c84ecce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84ecce0",
  null
  
)

export default component.exports